import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

export interface ComponentCanDeactivate {
  getForm: () => NgForm;
}

@Injectable()
export class WebhookPendingSubscriptionChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return !component || !component.getForm() || component.getForm().pristine || component.getForm().submitted ?
      true : confirm('You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
  }
}
